import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {
    baseUrl = `${baseUrl}/pre-agendamento-transporte`

    return {
        store(params) {
            return repository.post(`${baseUrl}`, params)
        },
        edit(id) {
            return repository.get(`${baseUrl}/${id}/edit`)
        },
        destroy(id) {
            return repository.delete(`${baseUrl}/${id}`)
        },
        destroyAll(params) {
            return repository.post(`${baseUrl}/delete-all`, params)
        },
        search(queryParms) {
            return repository.get(`${baseUrl}/search?${urlUtil.serialize(queryParms)}`)
        },
        update(params) {
            return repository.put(`${baseUrl}`, params)
        }
    }
}